import { render, staticRenderFns } from "./_novapay.vue?vue&type=template&id=c8ed6670&lang=pug&"
import script from "./_novapay.vue?vue&type=script&lang=js&"
export * from "./_novapay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports